/* eslint-disable max-len */
import {SERVICE_NAMES} from '../constants';
import {createApiCall, fetchAllPages} from '../utils';
import type {ServiceName} from '../constants';
import type {
    ApiCallOptions,
    PaginatedResponse,
    FeatureResource,
    StoreFeatureRequest,
    UpdateFeatureRequest,
    SetFeatureRequest,
    FeatureListParams
} from './api.d';

const createFeatureApiCall = <T = any>(
    method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH',
    endpoint: string
) => createApiCall<T>(SERVICE_NAMES.FEATURE as ServiceName, method, endpoint);

export const featureApi = {
    // Feature CRUD operations
    getFeatures: (params?: FeatureListParams, options?: ApiCallOptions) =>
        createFeatureApiCall<PaginatedResponse<FeatureResource>>('GET', 'features')({...options, params}),

    getFeature: (featureId: string, options?: ApiCallOptions) =>
        createFeatureApiCall<FeatureResource>('GET', `features/${featureId}`)({...options}),

    createFeature: (data: StoreFeatureRequest, options?: ApiCallOptions) =>
        createFeatureApiCall<FeatureResource>('POST', 'features')({...options, data}),

    updateFeature: (featureId: string, data: UpdateFeatureRequest, options?: ApiCallOptions) =>
        createFeatureApiCall<FeatureResource>('PUT', `features/${featureId}`)({...options, data}),

    deleteFeature: (featureId: string, options?: ApiCallOptions) =>
        createFeatureApiCall<void>('DELETE', `features/${featureId}`)({...options}),

    getAllFeatures: (params?: Omit<FeatureListParams, 'page'>, options?: ApiCallOptions) =>
        fetchAllPages<FeatureResource, {page?: number; per_page?: number; name?: string}>(
            (paginationParams: {page?: number; per_page?: number; name?: string}, opts?: ApiCallOptions) =>
                featureApi.getFeatures(paginationParams as unknown as FeatureListParams, opts),
            params || {},
            options
        ),

    // Account-specific feature operations
    getAccountFeatures: (accountId: string, options?: ApiCallOptions) =>
        createFeatureApiCall<FeatureResource[]>('GET', `accounts/${accountId}/features`)({...options}),

    setAccountFeature: (accountId: string, featureId: string, data: SetFeatureRequest, options?: ApiCallOptions) =>
        createFeatureApiCall<FeatureResource>('PUT', `accounts/${accountId}/features/${featureId}`)({...options, data})
};
